import { isJson } from './isJson';
export const jsonConvert = (data, type = 'string') => {
	if (!data) return '';
	else if (isJson(data)) return JSON.parse(data);
	else if (typeof data === 'object' && type === 'string')
		return JSON.stringify(data);
	return data;
};
